// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"_9wWj2","field":"I-6wx","field-label":"tMMOh","field-value":"H1cwC"};